import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DashboardOPEEnum} from "./DashboardOPEEnum";
import {WidgetEnum} from "../../components/widget/common/WidgetEnum";

class DashboardWidgetDTO {
  id!: number;
  widgetId!: number;
  widgetType!: WidgetEnum;
  name!: string;
  colsSize!: number;
  rowsSize!: number;
  colsStart!: number;
  rowsStart!: number;
  userConfig!: any;
  metricInstanceIds!: number[]
}

class O {
  dashboardWidgets!: DashboardWidgetDTO[];
}

/**
 * I Inner Class
 */
class I {
  dashboardId!: number;
}

/**
 * Impersonation-aware counterpart of getDashboardWidgets, which stays self-only: works for
 * the caller's own dashboards too, so it can replace it everywhere.
 */
export class GetAllUserDashboardWidgetsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DashboardOPEEnum.GetAllUserDashboardWidgets);
    this.i = new I();
    this.o = new O();
  }
}
